module.exports = __webpack_public_path__ + "assets/images/project/header/image-background-header-desktop.jpg?v=41747e8e";